import { render } from "./statistics_more.vue?vue&type=template&id=00e5f670"
import script from "./statistics_more.vue?vue&type=script&lang=js"
export * from "./statistics_more.vue?vue&type=script&lang=js"

import "./statistics_more.vue?vue&type=style&index=0&id=00e5f670&lang=less"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__